/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-22T09:43:57.718
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveHouseCoownerInfo,
	getHouseCoownerInfoCreateInit,
	getHouseCoownerInfoEditInit,
	getHouseCoownerInfoView,
	deleteHouseCoownerInfo
} from '@api/lcf/HouseCoownerInfo';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getHouseCoownerInfoCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getHouseCoownerInfoCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getHouseCoownerInfoEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHouseCoownerInfoEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveHouseCoownerInfo({}, HouseCoownerInfo) {
			return new Promise((resolve, reject) => {
				saveHouseCoownerInfo(HouseCoownerInfo)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getHouseCoownerInfoView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHouseCoownerInfoView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteHouseCoownerInfo({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteHouseCoownerInfo({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
